import { render } from "./DotsIcon.vue?vue&type=template&id=1b1c9e95"
const script = {}

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__